export const VENUE_CHURN_RISK_REVENUE_DROP_PCT = 0.3 as const
export const VENUE_CHURN_RISK_REVENUE_PRIOR_FLOOR = 100 as const
export const VENUE_CHURN_RISK_EVENT_LOOKBACK_DAYS = 30 as const
export const VENUE_CHURN_RISK_EVENT_LOOKAHEAD_DAYS = 30 as const

export const VenueChurnRiskSignal = {
  REVENUE_DROP: 'revenueDrop',
  NO_EVENTS_PAST_30D: 'noEventsPast30d',
  NO_EVENTS_NEXT_30D: 'noEventsNext30d',
} as const

export type VenueChurnRiskSignal =
  (typeof VenueChurnRiskSignal)[keyof typeof VenueChurnRiskSignal]
